// What a plant can produce this tick, before dispatch. Profile × weather.
import { sunAltitude } from './daylight';
import type { Balance, MapData, Plant, World } from './types';

/** Convert a per-half-day capacity to a per-tick amount. */
export function perTick(perHalfDay: number, balance: Balance): number {
  const ticksPerDay = balance.time.ticksPerHour * balance.time.hoursPerDay;
  return perHalfDay / (ticksPerDay / 2);
}

export function isPlantOnline(plant: Plant, world: World): boolean {
  return world.time.day >= plant.onlineDay;
}

/** Maximum output of a plant this tick, in units. */
export function plantOutputPerTick(
  plant: Plant,
  world: World,
  map: MapData,
  balance: Balance,
): number {
  if (!isPlantOnline(plant, world)) return 0;
  const cap = perTick(plant.capacity, balance);
  switch (plant.type) {
    case 'thermal':
      return cap;
    case 'solar': {
      const sun = sunAltitude(world.time.hour) * map.climate.sunFactor * (1 - world.weather.cloud);
      return cap * sun;
    }
    case 'wind':
      return world.weather.windy ? cap : 0;
    case 'hydro':
    case 'geothermal':
    case 'nuclear':
      return cap;
  }
}
